// IE 2026 10 26 / ODOO-pending (заказ Игоря 26.10: меню процессной модели — форма меню с группировкой)
// Плоский process_model_menu бэка (common_forms/home_page/views.py process_model_menu: «Current: …», ветки с _menuDepth и pi-share-alt,
// модели top-5 по title DESC, '-', команды веток / снимков / авто-пересчёта, '-', «Choice PM in list») → группы для бизнеса и пункты MenuPanel:
//   · «Process models» — ДЕРЕВО, как список справочника «Процесні моделі» (уточнение Игоря 26.10): модель → её What-if ветки и снимки;
//     колонки «Title» и «Date from»; текущая модель базы — первой с бейджем «Current»; тестовые копии — в конце дерева с бейджем «Test»;
//   · «Scenarios» — Create What-if branch / Create snapshot / Branch changes / Apply / Discard (те же команды бэка);
//   · «Auto-recalculation» — строка состояния (идёт / на паузе — по тому, какую команду прислал бэк) + Pause / Resume / Run now;
//   · «Choice PM in list» — футер панели «Open the full list».
// Чистые функции без импортов (t и формат даты — параметрами): юнит-тест tests/unit/pmMenuGroups.test.mjs.
// Необязательные поля пункта, если бэк их пришлёт (p054b): parent, kind ('snapshot'), date_from, owner, created_at, test_copy — иначе эвристики по названию / значку.

const SNAP_RE = /^snapshot\b/i
const TEST_RE = /(^|[^a-zа-яіїєґ])test([^a-zа-яіїєґ]|$)|\((копія|копия|copy)\)/i

// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): ночной архив ПМ — ветка-снимок вида archive (doc.branch.kind = 'archive', doc.branch.archive = { date, truncated }); бэк кладёт в пункт меню
// kind и (по дизайну ie-dm7) archive / archive_date. Дата архива: archive.date → archive_date → последняя дата ISO в названии («PM-2026 10 01 · 2026-10-26 (truncated copy)») → created_at
const ISO_RE = /(\d{4})-(\d{2})-(\d{2})/g
export function pmMenu_isArchive(r) {
    if (!r) return false
    if (r.kind === 'archive') return true
    const a = r.archive
    return !!(a && (typeof a === 'object' || typeof a === 'string'))
}
export function pmMenu_archiveDate(r) {
    if (!r) return ''
    const a = r.archive
    const d = (a && typeof a === 'object' ? a.date : (typeof a === 'string' ? a : '')) || r.archive_date || ''
    if (d) return String(d).slice(0, 10)
    const m = String(r.title || '').match(ISO_RE)
    if (m && m.length) return m[m.length - 1]
    return r.created_at ? String(r.created_at).slice(0, 10) : ''
}
// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): кнопка модели в шапке — название ОТКРЫТОЙ модели на языке интерфейса, как в меню (бот ie-dm7 #110546: шапка «(truncated copy)», меню «(усічена копія)»).
// Запись модели (process_model_record): title_<L> → meta.title_<L> → title; en / пустой язык — title
export function pmMenu_recTitle(rec, lang) {
    if (!rec || typeof rec !== 'object') return ''
    const L = String(lang || '')
    const base = String(rec.title || '')
    if (!L || L === 'en') return base
    const m = rec.meta && typeof rec.meta === 'object' ? rec.meta : {}
    const v = rec['title_' + L] || m['title_' + L]
    return typeof v === 'string' && v.trim() ? v : base
}
// значок открытой модели в шапке: архив — свой (pi-history, как в меню), иначе — прежний pi-sitemap. rec — process_model_record (doc.branch.kind) или пункт меню (kind / archive)
export const PM_ICON_ARCHIVE = 'pi-history'
export function pmMenu_recIcon(rec) {
    const br = rec && rec.doc && rec.doc.branch ? rec.doc.branch : (rec && rec.branch ? rec.branch : null)
    const arch = br ? br.kind === 'archive' : pmMenu_isArchive(rec)
    return arch ? PM_ICON_ARCHIVE : 'pi-sitemap'
}
// архивы — свежие сверху (дата DESC, при равной — название DESC)
export function pmMenu_archiveSort(list, dateOf = pmMenu_archiveDate) {
    return [...(list || [])].sort((x, y) => {
        const dx = dateOf(x), dy = dateOf(y)
        if (dx !== dy) return dx < dy ? 1 : -1
        const tx = String(x && x.title || ''), ty = String(y && y.title || '')
        return tx < ty ? 1 : tx > ty ? -1 : 0
    })
}

const methodOf = (r) => String((r && (r.method || (r.action && r.action.method))) || '')
const isSep = (r) => !r || r.title === '-'
const isModelItem = (r) => !!(r && r.command === 'set_process_model' && r.process_model)

// вид строки меню бэка
export function pmMenu_kind(r) {
    if (isSep(r)) return 'sep'
    if (isModelItem(r)) {
        const depth = +r._menuDepth || 0
        if (depth > 0 || r.parent) {
            if (pmMenu_isArchive(r)) return 'archive'   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ)
            if (r.kind === 'snapshot' || /\bpi-camera\b/.test(String(r.cssClass || '')) || SNAP_RE.test(String(r.title || ''))) return 'snapshot'
            return 'branch'
        }
        return 'model'
    }
    if (r.command === 'widget_open' && r.widget === 'widget-list' && r.params && r.params.isChoise_process_model) return 'list'
    const m = methodOf(r)
    if (/^auto_recalc_/.test(m)) return 'recalc'
    return 'action'
}

export function pmMenu_isTest(r, title) {
    if (!r) return false
    if (r.test_copy === true || (typeof r.test_copy === 'string' && r.test_copy)) return true
    return TEST_RE.test(String(title != null ? title : (r.title || '')))
}

// «Current: PM-2026 10 01» → «PM-2026 10 01» (префикс бэк локализует — отрезаем короткое «слово: » перед названием)
export function pmMenu_stripCurrent(title) {
    const s = String(title || '')
    const m = /^([^:]{1,24}):\s+(.+)$/.exec(s)
    return m ? m[2] : s
}

const nodeOf = (r, kind, title) => ({
    item: r, id: String(r.process_model), title: String(title != null ? title : (r.title || '')), kind,
    dateFrom: r.date_from ? String(r.date_from) : '', archiveDate: kind === 'archive' ? pmMenu_archiveDate(r) : '', owner: r.owner ? String(r.owner) : '', createdAt: r.created_at ? String(r.created_at) : '',
    children: [],
})

// список бэка → { current, models[], tests[], scenario[], recalc: { state: 'on' | 'paused' | '', items[] }, list }
// opts.currentId — модель базы по умолчанию (store.process_model_current), opts.currentTitle — её название (если известно — без разбора префикса)
export function pmMenu_groups(menu, opts = {}) {
    const out = { current: null, models: [], tests: [], scenario: [], recalc: { state: '', items: [] }, list: null }
    const rows = Array.isArray(menu) ? menu : []
    const byId = new Map()
    const stack = []   // последние узлы по глубине: stack[d] — узел глубины d
    let first = true
    for (const r of rows) {
        const kind = pmMenu_kind(r)
        if (kind === 'sep') continue
        if (kind === 'model' || kind === 'branch' || kind === 'snapshot' || kind === 'archive') {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ)
            const isCur = first && kind === 'model' && (!opts.currentId || String(r.process_model) === String(opts.currentId))
            first = false
            if (byId.has(String(r.process_model))) continue   // повтор id — бэк их не шлёт, но дерево без петель
            if (kind === 'model') {
                const title = isCur ? (opts.currentTitle || pmMenu_stripCurrent(r.title)) : r.title
                const n = nodeOf(r, 'model', title)
                n.current = isCur
                n.test = !isCur && pmMenu_isTest(r, title)
                byId.set(n.id, n)
                if (isCur) out.current = n
                else (n.test ? out.tests : out.models).push(n)
                stack.length = 0; stack[0] = n
                continue
            }
            const n = nodeOf(r, kind)
            n.test = false
            byId.set(n.id, n)
            const depth = Math.max(1, +r._menuDepth || 1)
            // родитель: явный parent (если бэк прислал), иначе — последний узел глубиной на 1 меньше (порядок бэка: ветки сразу под родителем)
            let parent = r.parent ? byId.get(String(r.parent)) : null
            if (!parent) parent = stack[depth - 1] || stack[stack.length - 1] || null
            if (parent) parent.children.push(n)
            else out.models.push(n)
            stack.length = depth; stack[depth] = n
            continue
        }
        first = false
        if (kind === 'list') { out.list = r; continue }
        if (kind === 'recalc') {
            const m = methodOf(r)
            if (m === 'auto_recalc_resume') out.recalc.state = 'paused'
            else if (m === 'auto_recalc_pause' && !out.recalc.state) out.recalc.state = 'on'
            out.recalc.items.push(r)
            continue
        }
        out.scenario.push(r)
    }
    return out
}

// все узлы дерева (обход в глубину)
export function pmMenu_walk(nodes, fn, depth = 0) {
    for (const n of nodes || []) { fn(n, depth); pmMenu_walk(n.children, fn, depth + 1) }
}

const ICON = { model: 'pi pi-sitemap', branch: 'pi pi-share-alt', snapshot: 'pi pi-camera', archive: 'pi pi-history' }   // IE 2026 10 27 / ODOO-5800: + archive

// группы → пункты MenuPanel (папки верхнего уровня — группы с заголовком)
// o.t — переводчик, o.fmtDate(iso) — дата для колонки, o.dateFromOf(node) — дата «с» по узлу (запасной источник: запись открытой модели)
// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): o.archiveSubmenu (по умолчанию вкл., выключатель fe.ux.pmArchiveSubmenu) — архивы модели свёрнуты в папку «Archive (N)» (foldable: MenuPanel
// раскрывает её щелчком, поиск ищет и внутри), свежие сверху, в колонке — дата архива; false — архивы обычными ветками, как прочие
export function pmMenu_panelItems(g, o = {}) {
    const t = o.t || ((s) => s)
    const fmt = o.fmtDate || ((s) => s)
    const dateOf = (n) => n.dateFrom || (o.dateFromOf ? (o.dateFromOf(n) || '') : '')
    const archOn = o.archiveSubmenu !== false
    const typeText = (n) => n.kind === 'archive' ? t('Daily archive (truncated copy)') : n.kind === 'snapshot' ? t('Snapshot (frozen view)') : n.kind === 'branch' ? t('What-if branch') : n.test ? t('Test model') : t('Process model')
    const item = (n) => {
        const df = n.kind === 'archive' ? (n.archiveDate || dateOf(n)) : dateOf(n)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): у архива в колонке — дата архива
        const badge = n.current ? { text: t('Current', null, 'pm'), cls: 'pm-badge-current', title: t('The current process model of the database') }
            : n.kind === 'snapshot' ? { text: t('Snapshot'), cls: 'pm-badge-snapshot', title: t('Snapshot (frozen view)') }
            : n.test ? { text: t('Test'), cls: 'pm-badge-test', title: t('Test model') } : null
        const r = {
            title: n.title, command: 'set_process_model', process_model: n.id, id: n.id,
            cssClass: ICON[n.kind] || ICON.model,
            'cssClass-row': 'pm-row pm-kind-' + (n.test ? 'test' : n.kind) + (n.current ? ' pm-db-current' : ''),
            aside: df ? fmt(df) : '',
            _pm: { id: n.id, kind: n.kind, test: !!n.test, current: !!n.current },
            _src: n.item,
            _tipRows: () => {
                const rows = {}
                rows[t('Type')] = typeText(n)
                if (n.kind === 'archive') { if (n.archiveDate) rows[t('Archive date')] = fmt(n.archiveDate); if (n.dateFrom) rows[t('Date from')] = fmt(n.dateFrom) }   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ)
                else if (df) rows[t('Date from')] = fmt(df)
                if (n.createdAt) rows[t('Created')] = fmt(n.createdAt)
                if (n.owner) rows[t('Owner')] = n.owner
                if (n.children.length) rows[t('Branches')] = String(n.children.length)
                return rows
            },
        }
        if (badge) r.badge = badge
        if (n.children.length) r.attrs = kids(n.children)
        return r
    }
    // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): дети узла — ветки / снимки как были, архивы — одной папкой «Archive (N)» в конце
    const archFolder = (arch) => {
        const sorted = pmMenu_archiveSort(arch, (n) => n.archiveDate)
        const latest = sorted[0] ? sorted[0].archiveDate : ''
        return {
            title: t('Archive ({n})', { n: sorted.length }), cssClass: ICON.archive, 'cssClass-row': 'pm-row pm-archive-folder',
            foldable: true, aside: latest ? fmt(latest) : '', attrs: sorted.map(item),
            _pmArchive: { n: sorted.length, latest },
            _tipRows: () => {
                const rows = {}
                rows[t('Type')] = t('Daily archives (truncated copies)')
                rows[t('Archives')] = String(sorted.length)
                if (latest) rows[t('Latest')] = fmt(latest)
                return rows
            },
        }
    }
    const kids = (list) => {
        if (!archOn) return list.map(item)
        const plain = list.filter(n => n.kind !== 'archive'), arch = list.filter(n => n.kind === 'archive')
        const out = plain.map(item)
        if (arch.length) out.push(archFolder(arch))
        return out
    }
    const tree = []
    tree.push({ title: t('Title'), aside: t('Date from'), 'cssClass-row': 'pm-colhead', _pmHead: true })
    if (g.current) tree.push(item(g.current))
    tree.push(...kids(g.models))   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): архив без родителя в списке — папкой в конце моделей
    for (const n of g.tests) tree.push(item(n))
    // IE 2026 10 26 / ODOO-pending (заказ Игоря 26.10: меню процессной модели — форма меню, p054c): названия команд бэка — через t() (словарь бэка их не переводит; уже локализованное / без ключа — как есть)
    const cmd = (r) => ({ ...r, title: r && typeof r.title === 'string' && r.title ? t(r.title) : r.title, _src: r })
    const groups = [{ title: t('Process models'), attrs: tree, _pmGroup: 'models' }]
    if (g.scenario.length) groups.push({ title: t('Scenarios'), attrs: g.scenario.map(cmd), _pmGroup: 'scenario' })
    if (g.recalc.items.length) {
        const paused = g.recalc.state === 'paused'
        const status = {
            title: t('Auto-recalc'), cssClass: 'pi pi-circle-fill', 'cssClass-row': 'pm-status ' + (paused ? 'pm-status-paused' : 'pm-status-on'),
            badge: paused ? { text: t('Paused'), cls: 'pm-badge-paused', title: t('Automatic recalculation on data changes is paused; changes are collected as drafts.') }
                : { text: t('On', null, 'autoRecalc'), cls: 'pm-badge-on', title: t('Data changes are recalculated automatically.') },
            aside: o.lastRun ? t('last run {at}', { at: fmt(o.lastRun) }) : '',
            _pmStatus: true,
        }
        groups.push({ title: t('Auto-recalculation'), attrs: [status, ...g.recalc.items.map(cmd)], _pmGroup: 'recalc' })
    }
    return groups
}

// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ)
// Плоский process_model_menu бэка для прежнего wj-menu (fe.ux.pmMenuForm = false, телефон): архивы каждого родителя → один пункт-подменю
// «Archive (N)» (attrs — архивы, свежие сверху) на месте первого архива этого родителя; остальное — как есть. Без архивов — тот же массив.
export function pmMenu_foldArchivesFlat(menu, o = {}) {
    const rows = Array.isArray(menu) ? menu : []
    if (!rows.some(r => isModelItem(r) && pmMenu_isArchive(r))) return rows
    const t = o.t || ((s) => s)
    const groups = new Map()
    let lastModel = ''
    const keyOf = (r) => String(r.parent || lastModel || '')
    for (const r of rows) {
        if (!isModelItem(r)) continue
        if (pmMenu_isArchive(r)) { const k = keyOf(r); if (!groups.has(k)) groups.set(k, []); groups.get(k).push(r) }
        else if (!(+r._menuDepth > 0)) lastModel = String(r.process_model)
    }
    const out = [], placed = new Set()
    lastModel = ''
    for (const r of rows) {
        if (isModelItem(r) && !pmMenu_isArchive(r) && !(+r._menuDepth > 0)) lastModel = String(r.process_model)
        if (!(isModelItem(r) && pmMenu_isArchive(r))) { out.push(r); continue }
        const k = keyOf(r)
        if (placed.has(k)) continue
        placed.add(k)
        const list = pmMenu_archiveSort(groups.get(k))
        out.push({ title: t('Archive ({n})', { n: list.length }), cssClass: 'pi pi-history', _menuDepth: +r._menuDepth || 1, attrs: list.map(x => ({ ...x, _menuDepth: 0 })), _pmArchiveFolder: true })
    }
    return out
}

// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ)
// Модели для меню чипсов (CHIP-ProcessModel, выбор модели в «Δ vs model»): { items: [{ process_model, title, kind }], archives: [{ process_model, title, date }] } —
// модели, ветки и снимки — по порядку бэка; архивы — отдельно, свежие сверху (o.archiveSubmenu === false — архивы в items, как прочие). o.exclude — id, которые не предлагать.
export function pmMenu_chipModels(menu, o = {}) {
    const archOn = o.archiveSubmenu !== false
    const ex = new Set((o.exclude || []).filter(Boolean).map(String))
    const items = [], arch = []
    const seen = new Set()
    for (const r of (Array.isArray(menu) ? menu : [])) {
        if (!isModelItem(r)) continue
        const id = String(r.process_model)
        if (ex.has(id) || seen.has(id)) continue
        seen.add(id)
        const kind = pmMenu_kind(r)
        if (kind === 'archive' && archOn) arch.push(r)
        else items.push({ process_model: id, title: String(r.title || id), kind })
    }
    const archives = pmMenu_archiveSort(arch).map(r => ({ process_model: String(r.process_model), title: String(r.title || r.process_model), date: pmMenu_archiveDate(r) }))
    return { items, archives }
}

// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): дата «2026-10-26» → по языку (uk / ru — 26.10.2026, en — 26/10/2026), как колонка формы меню; нечитаемое — как есть
export function pmMenu_fmtDate(s, lang = 'en') {
    const v = String(s || '')
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v)
    if (!m) return v
    try {
        return new Intl.DateTimeFormat(lang === 'en' ? 'en-GB' : lang, { year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(+m[1], +m[2] - 1, +m[3]))
    } catch (e) { return `${m[3]}.${m[2]}.${m[1]}` }
}

// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): строки меню чипса модели (CHIP-ProcessModel: kind 'pm') и выбора модели сравнения (CHIP-CompareModel: kind 'cmp').
// head — пункты перед моделями ({ id, title, aside?, icon? }); activeId — выбранный id (null — ни один); archOpen — папка «Archive (N)» раскрыта (true / false — щелчок пользователя;
// не задано — раскрыта, если выбран архив).
// Строка: { key, type: 'item' | 'folder', id, title, aside, icon, active, depth, open? }
export function pmMenu_chipRows(menu, o = {}) {
    const fmt = o.fmtDate || ((s) => s)
    const t = o.t || ((s) => s)
    const { items, archives } = pmMenu_chipModels(menu, { archiveSubmenu: o.archiveSubmenu, exclude: o.exclude })
    const act = o.activeId == null ? null : String(o.activeId)
    const icon = (k) => k === 'branch' ? 'pi-share-alt' : k === 'snapshot' ? 'pi-camera' : k === 'archive' ? 'pi-history' : 'pi-sitemap'
    const rows = []
    for (const h of (o.head || [])) rows.push({ key: 'h:' + h.id, type: 'item', id: String(h.id), title: h.title, aside: h.aside || '', icon: h.icon || 'pi-sitemap', active: act !== null && act === String(h.id), depth: 0 })
    for (const it of items) rows.push({ key: 'm:' + it.process_model, type: 'item', id: it.process_model, title: it.title, aside: '', icon: icon(it.kind), active: act !== null && act === it.process_model, depth: 0 })
    if (archives.length) {
        const hasAct = act !== null && archives.some(a => a.process_model === act)
        const open = o.archOpen == null ? hasAct : !!o.archOpen   // не трогали папку — раскрыта, если выбран архив
        rows.push({ key: 'archive', type: 'folder', id: '', title: t('Archive ({n})', { n: archives.length }), aside: archives[0].date ? fmt(archives[0].date) : '', icon: 'pi-history', active: false, depth: 0, open })
        if (open) for (const a of archives) rows.push({ key: 'a:' + a.process_model, type: 'item', id: a.process_model, title: a.title, aside: a.date ? fmt(a.date) : '', icon: 'pi-history', active: act !== null && act === a.process_model, depth: 1, archive: true })
    }
    return rows
}

// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): выбор модели сравнения в чипсе «Δ vs model» над параметрами отчёта (params — doc.params записи виджета, meta — rec._meta).
// id '' — «From settings»: prev_process_model / compare_with_prev / пометка «изменено» — как до первого выбора (pick); иначе prev_process_model = id, compare_with_prev включается
// (сравнение шло кнопкой Compare — обычный перечит иначе вернул бы отчёт без Δ; у копии-эталона compare_reference не трогается). → { pick: новое состояние (null — выбора нет), changed: нужен перечит }
export function pmMenu_cmpApply(params, meta, pick, id) {
    if (!params || !meta) return { pick: pick || null, changed: false }
    if (!id) {
        if (!pick) return { pick: null, changed: false }
        if (pick.has) params.prev_process_model = pick.v
        else delete params.prev_process_model
        if (pick.cwpHas) params.compare_with_prev = pick.cwp
        else delete params.compare_with_prev
        meta.modified = pick.modified
        return { pick: null, changed: true }
    }
    if (pick && String(params.prev_process_model || '') === String(id)) return { pick, changed: false }
    const next = pick || { has: 'prev_process_model' in params, v: params.prev_process_model, cwpHas: 'compare_with_prev' in params, cwp: params.compare_with_prev, modified: !!meta.modified }
    params.prev_process_model = String(id)
    if (!params.compare_with_prev && !params.compare_reference) params.compare_with_prev = true
    meta.modified = true
    return { pick: next, changed: true }
}
